module.exports = __webpack_public_path__ + "img/date.cc0e29f5.svg";